module.exports = __webpack_public_path__ + "img/mondstadt.194d98bc.jpg";